import { Link } from "react-router-dom";
import { Github, Facebook, Mail, MapPin } from "lucide-react";

const PROFILE_IMAGE = "https://customer-assets.emergentagent.com/job_devportfolio-122/artifacts/ev4aohwd_20250912_192904.jpg";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    {
      name: "GitHub",
      url: "https://github.com/Tsitsok98",
      icon: Github,
    },
    {
      name: "Facebook",
      url: "https://www.facebook.com/michelbergertsitsok",
      icon: Facebook,
    },
    {
      name: "Email",
      url: "mailto:michelbergertsitsok@gmail.com",
      icon: Mail,
    },
  ];

  return (
    <footer data-testid="footer" className="border-t border-border bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <img 
                src={PROFILE_IMAGE} 
                alt="Tsitsok Michel Berger"
                className="w-10 h-10 rounded-full object-cover"
              />
              <span className="font-heading font-bold text-xl text-foreground">
                Tsitsok Michel Berger
              </span>
            </Link>
            <p className="text-muted-foreground text-sm max-w-md mb-4">
              Ingénieur logiciel senior & consultant spécialisé dans le développement 
              d'applications web et mobiles performantes et sécurisées.
            </p>
            <div className="flex items-center gap-2 text-muted-foreground text-sm">
              <MapPin className="h-4 w-4" />
              <span>Cameroun</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading font-semibold text-foreground mb-4">
              Navigation
            </h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-muted-foreground hover:text-primary text-sm transition-colors"
                >
                  Blog
                </Link>
              </li>
              <li>
                <Link
                  to="/portfolio"
                  className="text-muted-foreground hover:text-primary text-sm transition-colors"
                >
                  Portfolio
                </Link>
              </li>
              <li>
                <Link
                  to="/a-propos"
                  className="text-muted-foreground hover:text-primary text-sm transition-colors"
                >
                  À propos
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-muted-foreground hover:text-primary text-sm transition-colors"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Social Links */}
          <div>
            <h4 className="font-heading font-semibold text-foreground mb-4">
              Me Suivre
            </h4>
            <div className="flex gap-3">
              {socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`footer-social-${social.name.toLowerCase()}`}
                  className="w-10 h-10 rounded-full bg-secondary flex items-center justify-center text-muted-foreground hover:text-primary hover:bg-primary/10 transition-all"
                >
                  <social.icon className="h-5 w-5" />
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-border mt-8 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-muted-foreground text-sm">
            © {currentYear} Tsitsok Michel Berger. Tous droits réservés.
          </p>
          <p className="text-muted-foreground text-sm">
            Développé par Tsitsok Team
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
